'use strict';
var angular = require('angular');
require('angular-sanitize');
require('angular-touch');
require('angular-loading-bar');
require('angular-ui-router');
require('ng-lodash');
require('angular-hotkeys');
require('angular-translate');
require('ng-dialog');
require('angular-google-analytics');
require('angular-cookies');

//external lib not in npm
require('re-tree');
require('./lib/ng-device-detector.js');
require('./lib/angular.audio.js');
require('./lib/angular-ellipsis.js');


//loading translation files
var translationsEN = require('../data/locale/en.json');
var translationsFI = require('../data/locale/fi.json');
var translationsSV = require('../data/locale/sv.json');

var app = angular
  .module('app', [
    'ngSanitize',
    'angular-loading-bar',
    'ng.deviceDetector',
    'ngLodash',
    'cfp.loadingBar',
    'ui.router',
    'cfp.hotkeys',
    'pascalprecht.translate',
    'ngDialog',
    'ngAudio',
    'angular-google-analytics',
    'dibari.angular-ellipsis',
    'ngCookies'
  ])
    .config(function($stateProvider, $urlRouterProvider, hotkeysProvider, $translateProvider, $locationProvider, AnalyticsProvider) {
      $urlRouterProvider.otherwise('/');

        // use the HTML5 History API
        $locationProvider.html5Mode(true);

      $stateProvider
        .state('dashBoard', {
            url: '/',
            controller: 'dashBoardController',
            controllerAs: 'dashBoard',
            template: require('./dash_board/template/dashBoard.html')
        })
        .state('slide_show', {
            url: '/slide_show',
            controller: 'slideShowController',
            template: require('./slide_show/template/slide_show.html')
        })
        .state('setting', {
            url: '/setting',
            controller: 'auctionSettingController',
            controllerAs: 'setting',
            template: require('./bidding_product/template/auction_setting.html')
        })
        .state('bidding_product', {
            url:'/bidding_product',
            controller: 'productBiddingController',
            controllerAs: 'biddingProduct',
            template: require('./bidding_product/template/product_table.html'),
            resolve: { authenticate: function authenticate($q, admin, $state, $timeout) {
                if (admin.isAuthenticated()) {
                    // Resolve the promise successfully
                    return $q.when();
                } else {
                    $timeout(function () {
                         // This code runs after the authentication promise has been rejected.
                         // Go to the log-in page
                         $state.go('setting');
                     });

                    // Reject the authentication promise to prevent the state from loading
                    return $q.reject();
                }
            }}
        });
      //disable auto generate help shortcut key info
      hotkeysProvider.includeCheatSheet = false;

        // add translation tables
        $translateProvider.translations('en', translationsEN);
        $translateProvider.translations('sv', translationsSV);
        $translateProvider.translations('fi', translationsFI);
        $translateProvider.preferredLanguage('fi');
        $translateProvider.fallbackLanguage('fi');

        $translateProvider.useSanitizeValueStrategy('sanitizeParameters');

        //google analytics
        AnalyticsProvider
            .logAllCalls(true)
            .startOffline(false);

        AnalyticsProvider
            .setAccount('UA-34469576-3');

        AnalyticsProvider.setDomainName('hagelstam.fi');
        //listen for page transition fuseCrossDomainLinkerrom UI-router
        AnalyticsProvider.setPageEvent('$stateChangeSuccess');
  });

require('./dash_board')(app);
require('./bidding_product')(app);
require('./slide_show')(app);
require('./main.scss');
//shared services
require('./shared')(app);


/*****************
 ** WEBPACK FOOTER
 ** ./index.js
 ** module id = 0
 ** module chunks = 0
 **/